module.exports = __webpack_public_path__ + "media/images/num1_ic-off-9c01e11d9e73c45dbb72e13330849f76.svg";